module.exports = __webpack_public_path__ + "media/images/greenFull-0b2f378ef51daaf4c531551b8d3e1989.svg";